"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = EnumerableCell;

var _react = _interopRequireDefault(require("react"));

var _cellContainer = _interopRequireDefault(require("./styled/cellContainer"));

var _cellContent = _interopRequireDefault(require("./styled/cellContent"));

var _enumerable = _interopRequireDefault(require("./styled/enumerable"));

function EnumerableCell() {
  return /*#__PURE__*/_react["default"].createElement(_cellContainer["default"], {
    role: "gridcell",
    tabIndex: -1,
    hideBorderRight: true
  }, /*#__PURE__*/_react["default"].createElement(_cellContent["default"], null, /*#__PURE__*/_react["default"].createElement(_enumerable["default"], null)));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/Table/body/enumerableCell.js
// module id = BuSO
// module chunks = 0